import { useState, useEffect } from 'react'

export const useHistory = (userId: string) => {
  const [history, sethistory]: any[] = useState([])
  const [filteredHistory, setfilteredHistory]: any[] = useState({
    my: [],
    all: [],
    high: []
  })

  const length = 50

  const addInHistory = (newHistory: any) =>
    sethistory((h: any) => [newHistory, ...h])

  useEffect(() => {
    const myHistory = history
      .filter((h: any) => h.user_id === userId)
      .slice(0, 18)
    const highHistory = history
      .filter((h: any) => h.bigWin === 2)
      .slice(0, length)
    const splicedhistory = history.slice(0, length)
    setfilteredHistory({
      my: myHistory,
      all: splicedhistory,
      high: highHistory
    })
  }, [history, userId])
  return [filteredHistory, addInHistory]
}
